/**
 * `Role` is an abstract class describing what a user can do on
 * another user. A role subclass is dedicated to roles of 1 kind
 * of user (e.g., `ConsultantRole` for `AgencyConsultant`).
 *
 * @abstract
 * @param {string} spec.agencyId - Identifier of the agency the role is bound to
 */
export default class Role extends Object {
	constructor({ agencyId, countryId } = {}) {
		super(...arguments);
		this._agencyId = agencyId;
		this._countryId = countryId;
	}

	getAgencyId() {
		return this._agencyId;
	}

	getCountryId() {
		return this._countryId;
	}

	//
	// canDelete
	//

	canDeleteUser(_user) {
		return false;
	}

	canBeDeletedByBackOffice() {
		return true;
	}

	canBeDeletedByCountryUser() {
		return false;
	}

	canBeDeletedByDirector() {
		return false;
	}

	canBeDeletedByConsultant() {
		return false;
	}

	canBeDeletedByCompanyAdmin() {
		return false;
	}

	canBeDeletedByCompanyNonAdmin() {
		return false;
	}

	//
	// canAttachOrDetachCompanyId
	//

	canAttachOrDetachCompanyId() {
		return false;
	}

	canCompanyIdBeAttachedOrDetachedByBackOffice() {
		return true;
	}

	canCompanyIdBeAttachedOrDetachedByCountryUser() {
		return false;
	}

	canCompanyIdBeAttachedOrDetachedByDirector() {
		return false;
	}

	canCompanyIdBeAttachedOrDetachedByConsultant() {
		return false;
	}

	canCompanyIdBeAttachedOrDetachedByCompanyAdmin() {
		return false;
	}

	canCompanyIdBeAttachedOrDetachedByCompanyNonAdmin() {
		return false;
	}

	// canEditUserInfo

	canEditUserInfo() {
		return false;
	}

	canUserInfoBeEditedByBackOffice() {
		return true;
	}

	canUserInfoBeEditedByCountryUser() {
		return false;
	}

	canUserInfoBeEditedByDirector() {
		return false;
	}

	canUserInfoBeEditedByConsultant() {
		return false;
	}

	canUserInfoBeEditedByCompanyAdmin() {
		return false;
	}

	canUserInfoBeEditedByCompanyNonAdmin() {
		return false;
	}

	// canViewAccountingDocuments

	canViewAccountingDocuments() {
		return false;
	}

	canViewBudgetEditor(_company) {
		return false;
	}

	canUpgradeSubscriptionPlanForCompany() {
		return false;
	}

	canAdministrateAgency(_agency) {
		return false;
	}

	canCreatePeriodReports(_company) {
		return false;
	}

	canAdministrateDocumentArchive() {
		return false;
	}

	canEditLightCompanies() {
		return false;
	}

	canChangeCompanyPackage(_company) {
		return false;
	}

	canManagePackages() {
		return false;
	}

	canExtractDataFromCompany(_company) {
		return false;
	}

	canDeleteCompany(_company) {
		return false;
	}

	canShareChartOfAccounts() {
		return false;
	}

	_isForSameAgency(role) {
		const agencyId = this.getAgencyId();
		const otherAgencyId = role.getAgencyId();
		return agencyId && otherAgencyId && agencyId === otherAgencyId;
	}

	_isForSameCountry(role) {
		const countryId = this.getCountryId();
		const otherCountryId = role.getCountryId();
		return countryId && otherCountryId && countryId === otherCountryId;
	}
}
